"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var bytes = _interopRequireWildcard(require("../../../helpers/byte-helpers"));

var _types = _interopRequireDefault(require("../../../types"));

var _pesPacket = _interopRequireDefault(require("./pes-packet"));

var _accessUnit = _interopRequireDefault(require("./access-unit"));

var _adts = _interopRequireDefault(require("./adts"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ElementaryStream =
/*#__PURE__*/
function () {
  _createClass(ElementaryStream, null, [{
    key: "parse",

    /**
     * @static parse - Parse an elementary stream out of transport stream
     *
     * @param  {TransportStream} transportStream Transport stream that contains all packets
     * @param  {Integer} streamType      Code for the stream you want to parse out (27 = vid / 15 = audio)
     * @return {ElementaryStream}        An ElementaryStream object with all parsed chunks in a chunks array
     */
    value: function parse(transportStream, streamType, trackID) {
      var es = new ElementaryStream(streamType);
      es.trackID = trackID;
      var pmt = transportStream.packets.filter(function (p) {
        return p.objType === _types.default.PMT;
      })[0];
      var track = pmt.programs[0].tracks.filter(function (t) {
        return t.streamType === streamType;
      })[0];

      if (!pmt) {
        throw 'PMT not present in transport stream';
      }

      if (!track) {
        throw 'Track for stream type not found';
      }

      var streamPackets = transportStream.packets.filter(function (p) {
        return p.header.PID === track.elementaryPID;
      });
      var delimiter;

      if (streamType === 27) {
        delimiter = 0xe0;
      }

      if (streamType === 15) {
        delimiter = 0xc0;
      }

      if (streamType === 21) {
        return es;
      }

      if (streamPackets.length === 0) {
        return es;
      } // console.log('LENGTH CHECK');


      if (packetsHaveLength(streamPackets, delimiter)) {
        // console.log('GOT LENGTH');
        es.packets = parsePacketsByHeaders(streamPackets, delimiter);
      } else {
        // console.log('BY CHUNK');
        es.packets = parsePacketsByChunks(streamPackets, delimiter);
      }

      return es;
    }
  }]);

  function ElementaryStream(streamType) {
    _classCallCheck(this, ElementaryStream);

    this.streamType = streamType;
    this.packets = [];
  }
  /**
   * get codec - Parses the codec informatino out of the stream
   *
   * @return {type}  description
   */


  _createClass(ElementaryStream, [{
    key: "codec",
    get: function get() {
      // Video
      if (this.streamType === 27) {
        var c = this.codecBytes;
        var arrayBuffer = Uint8Array.from(c[0]);
        var view = new DataView(arrayBuffer.buffer);
        var version = view.getUint8(0);
        var profile = view.getUint8(1);
        var profileCompatibility = view.getUint8(2);
        var levelIndication = view.getUint8(3);
        var params = [profile, profileCompatibility, levelIndication].map(function (i) {
          return ('0' + i.toString(16).toUpperCase()).slice(-2);
        }).join('');
        return ['avc1', params].join('.');
      }

      if (this.streamType === 15) {
        var _c = this.codecBytes;
        return ['mp4a', 40, _c.header.profileMinusOne + 1].join('.');
      }

      return undefined;
    }
  }, {
    key: "codecBytes",
    get: function get() {
      if (this.streamType === 27) {
        var result = _accessUnit.default.parse(this);

        var sps = result.sps;
        var pps = result.pps;
        return [sps.rbsp, pps.rbsp];
      }

      if (this.streamType === 15) {
        return _adts.default.parse(this).units[0];
      }
    }
  }]);

  return ElementaryStream;
}();

var packetsHaveLength = function packetsHaveLength(packets, delimiter) {
  var itr = bytes.elementaryStreamIterator(packets, [0, 0, 1, delimiter], true);
  var next = itr.next();

  if (next) {
    var buffer = new Uint8Array(next);
    var reader = new bytes.BitReader(buffer);
    var pesPacket = new _pesPacket.default(reader, 0);

    if (pesPacket.header.packetLength) {
      return true;
    }
  }

  return false;
};

var parsePacketsByHeaders = function parsePacketsByHeaders(packets, delimiter) {
  var results = [];
  var cnt = 0;
  var reader = bytes.streamReader(packets);
  var sync = new Uint8Array([255, 255, 255]);

  while (1) {
    if (reader.atEnd()) {
      break;
    }

    var byte = reader.readBits(8);

    if (byte === undefined) {
      break;
    }

    sync[2] = sync[1];
    sync[1] = sync[0];
    sync[0] = byte;

    if (sync[2] === 0x00 && sync[1] === 0x00 && sync[0] === 0x01) {
      var next = reader.readBits(8);

      if (next === delimiter) {
        reader.rewind(32);
        var pesPacket = new _pesPacket.default(reader, cnt++);
        results.push(pesPacket);
      } else {
        reader.rewind(8);
      }
    }
  }

  return results;
};

var parsePacketsByChunks = function parsePacketsByChunks(packets, delimiter) {
  var results = [];
  var itr = bytes.elementaryStreamIterator(packets, [0, 0, 1, delimiter], true);
  var cnt = 0;

  while (1) {
    var next = itr.next();

    if (next) {
      var buffer = new Uint8Array(next);
      var reader = new bytes.BitReader(buffer);
      var pesPacket = new _pesPacket.default(reader, cnt++);
      results.push(pesPacket);
    } else {
      break;
    }
  }

  return results;
};

var _default = ElementaryStream;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/parsers/container/ts/elementary-stream.js
// module id = 129
// module chunks = 0